import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { AppErrorBoundary } from './components/AppErrorBoundary'
import { initializeDesktopPwa } from './pwa'
import { useEditorStore } from './store'
import './styles.css'

initializeDesktopPwa()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary
      scope="application"
      getProject={() => useEditorStore.getState().project}
      onExit={() => {
        useEditorStore.getState().setProject(null)
        window.location.reload()
      }}
    >
      <App />
    </AppErrorBoundary>
  </StrictMode>,
)
